import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_USUARIOS

export default class CargosService {
  paginate () {
    return http.get(`${baseUrl}/listar-cargos`, {
      headers: {
        loading: true
      }
    })
  }
}
